import React from 'react'

import dayjs from 'dayjs'
import { isNull } from 'lodash'
import { Link } from 'react-router-dom'

import { content } from './switching-information.content'
import classes from './switching-information.module.scss'
import type { SwitchingInformationProps } from './switching-information.types'
import { Icon, Typography } from '../index'

export const SwitchingInformation = (props: SwitchingInformationProps) => {
  const { codeType, codeValue, expiryDate, link, title = content.title } = props

  return (
    <div className={classes.container}>
      {!isNull(title) && (
        <Typography
          component="h2"
          variant="Kollektif/BodyTextLgBold"
          className={classes.title}
        >
          {title}
        </Typography>
      )}

      <div className={classes.card}>
        <div className={classes.information}>
          <Typography variant="Kollektif/Small" className={classes.code}>
            {codeType}: {codeValue}
          </Typography>
          <Typography variant="Kollektif/ExtraSmall" className={classes.expiry}>
            Expires: {dayjs(expiryDate).format('DD MMMM YYYY')}
          </Typography>
        </div>

        <Link
          to={{
            pathname: link,
            state: { hideSequence: true },
          }}
          className={classes.link}
        >
          <Icon name="chevron" className={classes.chevron} />
        </Link>
      </div>
    </div>
  )
}
